/* IGNIERE §321 サイトの中のどの部品から次のページへ移ったかを GA4 へ送る（2026-10-14・代表「前の案で進めてください」・tasks.js #229）
   - 送る出来事＝ig_nav_click。中身＝nav_area（押した部品の場所）・nav_part（部品の種類）・link_url（行き先の住所・?以降は落とす）・link_text（見えている文字・50 字まで）・page_type（今のページの種類）
   - nav_area の決め方（上から順に当てる）
       1. 部品か先祖に data-ig-nav="名前" があればそれ（手で名前を付けたい時だけ使う）
       2. メガメニュー（.ig-mega）＝mega_menu:products／mega_menu:scenes（開いた面の名前）・ハンバーガーの引き出し（.ig-drawer）＝drawer_menu・検索の窓（予測検索）＝search_modal・ヘッダーのロゴ＝header_logo
       3. それ以外は、Shopify の区画の名前（例 template--…__categories → categories・sections--…__footer → footer・末尾の 6 文字の乱数は落とす）
     ＝区画を足しても名前は自動で付く。ただし区画の名前（テンプレートの JSON の key）は意味のある名前にする＝テーマエディタで足すと乱数つきの型の名前になり、同じ型が 2 つあると区別できない
     ＝区画の外に置く部品（ヘッダー・引き出し・窓など）を新しく作ったら、ここに足すか data-ig-nav を付ける（HANDOFF.md §3「計測の名前」）
   - 送り方：GA4 は Google & YouTube アプリがページの上で動かしている（2026-10-14 実測＝window.gtag がある）ので、gtag で直接送る。
     Shopify.analytics.publish で送った出来事は、アプリが GA4 へ送らなかった（同日実測）。将来カスタムピクセルで受けられるよう、同じ中身を publish でも出しておく
   - 外のサイトへのリンク・#だけのリンク・javascript: は送らない。お客さんの名前やメールは扱わない
   - GA4 の画面で nav_area などを見るには、GA4 の管理画面で「カスタム ディメンション」に登録が要る。BigQuery の書き出しには登録しなくても入る
   §321-2（2026-10-14・メガメニューの作り直しの会話からの依頼・代表「仕掛けの作成はGA4の役割」）メニューを「開いた」記録 ig_nav_open
   - 用途＝「メニューを開いた訪問のうち、一覧や商品へ移った割合」の分母。中身は ig_nav_click と同じ名前の項目＋open_method（click／key／hover）
   - 拾い方＝メニューの仕掛け（igniere-mega-menu.js）には手を入れず、開いた印の変化を見張る（MutationObserver）
       ・.ig-mega／.ig-drawer の中か data-ig-nav-open を持つ要素で、aria-expanded か aria-selected が "true" になった時（メガメニューの見出し・ドロワーの開閉ボタン・タイル）
       ・ドロワーの中の details が開いた時（CATEGORY・SCENE・MAGAZINE）。ドロワー自体が開いている間だけ
       ・お客さんの操作で開いた物だけ数える＝直前 1 秒以内にその要素の中を押した（click／key）か、マウスが乗っている（hover）。閉じる時の初期の形への戻し（CATEGORY を開き直す）は数えない
       ・hover で開いた物は 0.5 秒たっても開いたままの時だけ数える（§327-12・点検 F6＝行をなぞるたびに出ていた）
   - nav_area＝メガメニューの見出しは mega_menu:<面の名前>・ドロワーの開閉は drawer_menu・ドロワーの中の details は drawer_menu:<見出しの英語の小文字>（category・scene・magazine）。data-ig-nav-open="名前" があればそれ
   - ドロワーの中の押下も、details の中なら drawer_menu:<見出し>（例 drawer_menu:category）に分ける。部品の種類（nav_part）は自分にクラスが無ければ近い先祖の ig- のクラス
   §378-3（2026-10-27・代表「進めてください」・設計＝60_開発/shopify/作業/買い回りの棚_2026-10/設計書.md 3-2・6-6）買い回りの棚の計測
   - ig_nav_click に 3 つ足す（棚の中で押した時だけ）＝shelf（related・checked・recommended・new_arrival・coordinate・related_brands）・
     item_position（その棚の中で何番目のカードか・1 から）・shelf_mode（both＝タブ・related などの単独＝タブ無し）。nav_area は今までどおり（週の集計 segments.py が読む）
   - ig_shelf_view＝棚が実際に画面に出た記録（押された数を割る分母）。棚の箱の半分が画面に入った時に、ページを開いてから棚ごとに 1 回。
     タブで隠れている棚は画面に入らない＝タブを切り替えて出た時に数える。中身＝shelf・shelf_mode・item_count（カードの数）・nav_area・page_type
   - 棚の名前の出どころ＝[data-ig-shelf-pane]（商品ページのタブ・TOP とカートで記録のある人のタブ＝igniere-shelf-tabs.js が付ける）か、区画の名前（SHELF_SECTIONS） */
(function () {
  'use strict';
  if (window.__igNavTracking) return;
  window.__igNavTracking = true;

  var CUSTOM_EVENT = 'igniere:nav_click';
  var CUSTOM_OPEN_EVENT = 'igniere:nav_open';
  var lastPress = { target: null, time: 0, type: '' };

  function measurementId() {
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      var x = dl[i];
      if (x && x[0] === 'config' && typeof x[1] === 'string' && x[1].indexOf('G-') === 0) return x[1];
    }
    return null;
  }

  function sectionKey(el) {
    var sec = el.closest('.shopify-section');
    if (!sec || !sec.id) return 'other';
    var id = sec.id.replace(/^shopify-section-/, '');
    var m = id.match(/__(.+)$/);
    return (m ? m[1] : id).replace(/_[A-Za-z0-9]{6}$/, '');
  }

  // ドロワーの中の見出し（details の summary の最初の文字＝CATEGORY など）を名前にする
  function detailsName(d) {
    var summary = d.querySelector(':scope > summary');
    if (!summary) return 'section';
    var label = summary.querySelector('[class*="__label"]') || summary;
    for (var i = 0; i < label.childNodes.length; i++) {
      var node = label.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim()) {
        return node.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '') || 'section';
      }
    }
    return 'section';
  }

  function areaOf(a) {
    var named = a.closest('[data-ig-nav]');
    if (named) return named.getAttribute('data-ig-nav');
    var trigger = a.closest('[data-ig-mega-trigger]');
    if (trigger) return 'mega_menu:' + trigger.getAttribute('data-ig-mega-trigger');
    if (a.closest('.ig-mega')) {
      var panel = a.closest('[data-ig-mega-panel]');
      return panel ? 'mega_menu:' + panel.getAttribute('data-ig-mega-panel') : 'mega_menu';
    }
    var drawer = a.closest('.ig-drawer');
    if (drawer) {
      var details = a.closest('details');
      return details && drawer.contains(details) ? 'drawer_menu:' + detailsName(details) : 'drawer_menu';
    }
    if (a.closest('.predictive-search-form, predictive-search-component, .search-modal, dialog[class*="search"]')) return 'search_modal';
    if (a.classList.contains('header-logo')) return 'header_logo';
    return sectionKey(a);
  }

  function igClass(el) {
    var cls = (el.className && typeof el.className === 'string') ? el.className.split(/\s+/) : [];
    for (var i = 0; i < cls.length; i++) {
      if (cls[i].indexOf('ig-') === 0) return cls[i];
    }
    return null;
  }

  // 自分のクラスが無いリンク（メガメニューの「すべて見る」・機能・目的の列など）は、3 段上までの先祖の ig- のクラスで呼ぶ
  function partOf(a) {
    var own = igClass(a);
    if (own) return own;
    var el = a.parentElement;
    for (var depth = 0; el && depth < 3; depth++, el = el.parentElement) {
      var up = igClass(el);
      if (up) return up;
    }
    var cls = (a.className && typeof a.className === 'string') ? a.className.split(/\s+/) : [];
    return cls[0] || a.tagName.toLowerCase();
  }

  function decodePath(p) {
    try { return decodeURIComponent(p).slice(0, 100); } catch (err) { return p.slice(0, 100); }
  }

  function pageType() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (m && m.pageType) return m.pageType;
    return location.pathname === '/' ? 'home' : location.pathname.split('/')[1] || 'other';
  }

  function send(name, customEvent, params) {
    try {
      if (typeof window.gtag === 'function') {
        var id = measurementId();
        var p = Object.assign({}, params);
        if (id) p.send_to = id;
        window.gtag('event', name, p);
      }
    } catch (err) { /* 送れなくてもページの動きは止めない */ }
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(customEvent, params);
      }
    } catch (err) { /* 同上 */ }
  }

  // 見えている文字（50 字まで）。文字の無いリンク（アイコンだけ）は aria-label。details は summary の見出しの文字だけ
  function textOf(el, opening) {
    if (el.tagName === 'DETAILS') {
      var summary = el.querySelector(':scope > summary');
      if (summary) el = summary;
    }
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text && !opening) text = (el.getAttribute('aria-label') || '').trim();
    // §327-6 ロゴだけの札（TOP のブランドのタブ）は中の画像の alt（点検 F5）
    if (!text && !opening) { var im = el.querySelector && el.querySelector('img[alt]'); if (im) text = im.getAttribute('alt').trim(); }
    return text.slice(0, 50);
  }

  function onClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
    var url;
    try { url = new URL(href, location.href); } catch (err) { return; }
    if (url.host !== location.host) return;
    var params = {
      nav_area: areaOf(a),
      nav_part: partOf(a),
      link_url: decodePath(url.pathname),
      link_text: textOf(a),
      page_type: pageType()
    };
    var sh = shelfOf(a);
    if (sh) {
      params.shelf = sh.name;
      params.shelf_mode = modeOf(sh.box);
      var pos = positionOf(a, sh.box);
      if (pos) params.item_position = pos;
    }
    send('ig_nav_click', CUSTOM_EVENT, params);
  }

  document.addEventListener('click', onClick, true);

  // ── §378-3 買い回りの棚 ──
  var SHELF_SECTIONS = { new_arrival: 'new_arrival', recommended: 'recommended', also_like: 'recommended', coordinate: 'coordinate', 'related-brand': 'related_brands', 'same-category': 'related' };
  var CARD = '.resource-list__item, .ig-card, .ig-brand-card, li';
  // 棚の箱（名前の付いたタブの中身、無ければ区画）と名前。棚の外なら null
  function shelfOf(el) {
    var pane = el.closest('[data-ig-shelf-pane]');
    if (pane) return { box: pane, name: pane.getAttribute('data-ig-shelf-pane') };
    var sec = el.closest('.shopify-section');
    var name = sec && SHELF_SECTIONS[sectionKey(el)];
    return name ? { box: sec, name: name } : null;
  }
  function modeOf(box) {
    var root = box.closest('[data-mode]');
    return root ? root.getAttribute('data-mode') : 'single';
  }
  function cardsIn(box) {
    var list = box.querySelectorAll('.resource-list__item, .ig-card');
    return list.length ? list : box.querySelectorAll('li');
  }
  function positionOf(a, box) {
    var card = a.closest(CARD);
    if (!card) return null;
    var list = Array.prototype.slice.call(cardsIn(box));
    var i = list.indexOf(card);
    if (i < 0) for (var k = 0; k < list.length; k++) { if (list[k].contains(a)) { i = k; break; } }
    return i < 0 ? null : i + 1;
  }
  var seenShelf = new WeakSet();
  var shelfIO = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting || seenShelf.has(en.target)) return;
      var box = en.target;
      var n = cardsIn(box).length;
      if (!n) { // 中身がまだ無い（RELATED の取り寄せ前など）＝出た数に入れず、少し待って見張り直す（見張り直すと今の状態で呼ばれ直す）
        shelfIO.unobserve(box);
        setTimeout(function () { shelfIO.observe(box); }, 1500);
        return;
      }
      var sh = shelfOf(box);
      if (!sh) return;
      seenShelf.add(box);
      send('ig_shelf_view', 'igniere:shelf_view', {
        shelf: sh.name, shelf_mode: modeOf(box), item_count: n, nav_area: sectionKey(box), page_type: pageType()
      });
    });
  }, { threshold: 0.5 }) : null;
  function watchShelves() {
    if (!shelfIO) return;
    document.querySelectorAll('[data-ig-shelf-pane]').forEach(function (p) { shelfIO.observe(p); });
    Object.keys(SHELF_SECTIONS).forEach(function (key) {
      document.querySelectorAll('.shopify-section[id$="__' + key + '"]').forEach(function (sec) {
        if (!sec.querySelector('[data-ig-shelf-pane]')) shelfIO.observe(sec); // タブのある区画は中身の箱の側で数える（重ねて数えない）
      });
    });
  }
  // 棚の箱は後から作られる物がある（TOP とカートのタブ・RELATED の中身）＝読み込みの後と、タブができた合図で見張り直す（見張りの重ね掛けは無害）
  window.addEventListener('load', watchShelves);
  document.addEventListener('ig:shelf-ready', watchShelves);

  // ── §321-2 メニューを開いた記録（ig_nav_open） ──
  function remember(type) {
    return function (e) { lastPress = { target: e.target, time: Date.now(), type: type }; };
  }
  document.addEventListener('pointerdown', remember('click'), true);
  document.addEventListener('keydown', remember('key'), true);

  // お客さんの操作で開いたか（押した・キーで開いた・マウスが乗っている）。それ以外（閉じる時の初期の形への戻しなど）は null
  function methodOf(el) {
    var t = lastPress.target;
    if (t instanceof Node && Date.now() - lastPress.time < 1000 && el.contains(t)) return lastPress.type;
    // §327-6 タブの矢印キー＝押したのは前のタブ・開いたのは次のタブ（同じ tablist の中）。見ないと数えず、マウスが残ると hover と誤る（点検 F4）
    var tl = el.closest ? el.closest('[role="tablist"]') : null;
    if (tl && t instanceof Node && Date.now() - lastPress.time < 1000 && tl.contains(t)) return lastPress.type;
    try { if (el.matches(':hover')) return 'hover'; } catch (err) { /* 古いブラウザ */ }
    return null;
  }

  // §327-12（点検 F6）マウスが通り過ぎただけの「開いた」は数えない。メガメニューの左の行は乗せるだけで替わるので、上から下へなぞると 7 行で 6 件出ていた。
  // hover で開いた物は 0.5 秒待ち、まだ開いたまま（行なら選ばれたまま）の時だけ送る。押した・キーで開いた物はすぐ送る
  var HOVER_DWELL = 500;
  function stillOpen(el, attr) {
    return attr === 'open' ? el.hasAttribute('open') : el.getAttribute(attr) === 'true';
  }

  function onOpened(el, attr) {
    var method = methodOf(el);
    if (!method) return;
    if (method === 'hover') {
      setTimeout(function () { if (stillOpen(el, attr)) sendOpen(el, method); }, HOVER_DWELL);
      return;
    }
    sendOpen(el, method);
  }

  function sendOpen(el, method) {
    send('ig_nav_open', CUSTOM_OPEN_EVENT, {
      nav_area: el.getAttribute('data-ig-nav-open') || areaOf(el),
      nav_part: partOf(el),
      link_text: textOf(el, true),
      page_type: pageType(),
      open_method: method
    });
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      var el = r.target;
      if (!(el instanceof Element) || !el.closest('.ig-mega, .ig-drawer, [data-ig-nav-open]')) continue;
      // §334 閉じた後に左の一覧・タブを最初の 1 つへ戻す動き（igniere-mega-v2.js の reset）は数えない。タブの上で Esc を押して閉じると、
      // 押したのが同じ tablist の中＝「キーで開いた」と 1 件数えていた（2026-10-16 実測・CATEGORY・SCENE・MAGAZINE とも）
      var megaRoot = el.closest('.ig-mega');
      if (megaRoot && r.attributeName === 'aria-selected' && !megaRoot.hasAttribute('data-open')) continue;
      if (r.attributeName === 'open') {
        if (r.oldValue !== null || !el.hasAttribute('open')) continue;
        var drawer = el.closest('.ig-drawer');
        if (drawer && !drawer.hasAttribute('data-open')) continue;
        onOpened(el, 'open');
      } else if (el.getAttribute(r.attributeName) === 'true' && r.oldValue !== 'true') {
        onOpened(el, r.attributeName);
      }
    }
  }

  if (window.MutationObserver && document.body) {
    new MutationObserver(onMutations).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['aria-expanded', 'aria-selected', 'open']
    });
  }
})();
